import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";
import React, { useEffect, useRef, useState } from 'react';
import PegPie from "./PegPie";
import { formatLongDate } from "../../util/helper/formatDate";
import { PegsRedeemed } from "./PegsRedeemed";
import { useFlags } from 'launchdarkly-react-client-sdk';
import { RewardsCardDetail } from './RewardsCardDetail';
import RewardCardModal from './RewardCardModal';

var RewardCard = function RewardCard(_ref) {
  var item = _ref.item,
      rewardsActivityFields = _ref.rewardsActivityFields;

  var _useState = useState(null),
      _useState2 = _slicedToArray(_useState, 2),
      points = _useState2[0],
      setPoints = _useState2[1];

  var _useState3 = useState(''),
      _useState4 = _slicedToArray(_useState3, 2),
      detailsString = _useState4[0],
      setDetailsString = _useState4[1];

  var _useState5 = useState(false),
      _useState6 = _slicedToArray(_useState5, 2),
      modalEnabled = _useState6[0],
      setModalEnabled = _useState6[1];

  var _useState7 = useState(false),
      _useState8 = _slicedToArray(_useState7, 2),
      showRewardCardModal = _useState8[0],
      setShowRewardCardModal = _useState8[1];

  var flags = useFlags();
  var releaseRewardsActivityApiV2Dstr5181 = flags['releaseRewardsActivityApiV2Dstr5181'] ? flags['releaseRewardsActivityApiV2Dstr5181'] : false;
  var detailedCards = ['SPIN_PEG_REWARD', 'REWARD_EARNED'];
  var divRef = useRef(null);
  useEffect(function () {
    if (releaseRewardsActivityApiV2Dstr5181) {
      setDetailsString(item.apiDetail);
      setPoints(item.rewardsPointsEarned);

      if (rewardsActivityFields && item.rewardDetailThumbnailImage) {
        var backgroundImage = null;
        var backgroundObj;

        switch (item.activityCardType) {
          case 'SPIN_PEG_REWARD':
            backgroundObj = rewardsActivityFields === null || rewardsActivityFields === void 0 ? void 0 : rewardsActivityFields.find(function (image) {
              var _image$fields, _image$fields$code;

              return ((_image$fields = image.fields) === null || _image$fields === void 0 ? void 0 : (_image$fields$code = _image$fields.code) === null || _image$fields$code === void 0 ? void 0 : _image$fields$code.value) === 'FreePegsBonusReward';
            });

            if (backgroundObj) {
              backgroundImage = backgroundObj.fields.backgroundImage;
            }

            break;

          case 'REWARD_EARNED':
            backgroundObj = rewardsActivityFields === null || rewardsActivityFields === void 0 ? void 0 : rewardsActivityFields.find(function (image) {
              var _image$fields2, _image$fields2$code;

              return ((_image$fields2 = image.fields) === null || _image$fields2 === void 0 ? void 0 : (_image$fields2$code = _image$fields2.code) === null || _image$fields2$code === void 0 ? void 0 : _image$fields2$code.value) === 'BonusRewards';
            });

            if (backgroundObj) {
              backgroundImage = backgroundObj.fields.backgroundImage;
            }

            setModalEnabled(true);
            break;
        }

        if (backgroundImage) {
          divRef.current.style.backgroundImage = "url(".concat(backgroundImage.value.src, ")");
          divRef.current.style.backgroundSize = 'cover';
          divRef.current.style.backgroundPosition = 'center';
        }
      }
    } else {
      if (item.mappedOrderNumber && item.mappedEventType === 'orderItem') {
        setDetailsString("Order #".concat(item.mappedOrderNumber, " | ").concat(item.handOffType));
      } else if (item.mappedEventType === 'rewardItem') {
        setDetailsString(item.apiDetail);
      }

      setPoints(item.rewardsPointsRedeemed || item.rewardsPointsEarned);
      divRef.current.style.backgroundImage = 'none';
    }
  }, [releaseRewardsActivityApiV2Dstr5181]);

  var handleOnClickRewardCard = function handleOnClickRewardCard() {
    if (modalEnabled) {
      setShowRewardCardModal(true);
    }
  };

  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(RewardCardModal, {
    show: showRewardCardModal,
    hide: function hide() {
      console.log('hide');
      setShowRewardCardModal(false);
    },
    model: item || {}
  }), /*#__PURE__*/React.createElement("div", {
    ref: divRef,
    className: "cb-reward-card",
    onClick: handleOnClickRewardCard
  }, /*#__PURE__*/React.createElement("div", {
    className: "leftCol"
  }, /*#__PURE__*/React.createElement("div", {
    className: "cb-account-card__header"
  }, /*#__PURE__*/React.createElement("h3", null, formatLongDate(item.transactionDate))), /*#__PURE__*/React.createElement("div", {
    className: "cb-account-order"
  }, /*#__PURE__*/React.createElement("h4", {
    className: "cb-account-order__title"
  }, detailsString)), item.pegsRedeemedOnOrder > 0 && /*#__PURE__*/React.createElement(PegsRedeemed, {
    pegs: item.pegsRedeemedOnOrder
  }), releaseRewardsActivityApiV2Dstr5181 && detailedCards.includes(item.activityCardType) && /*#__PURE__*/React.createElement(RewardsCardDetail, item)), /*#__PURE__*/React.createElement("div", {
    className: "cb-reward-card__rightCol"
  }, points ? /*#__PURE__*/React.createElement(PegPie, {
    number: points
  }) : "")));
};

export default RewardCard;